import { client } from '../../../../../common-utils/libraries/axios/axios';
import { TOKEN } from '../apiUrls';

const mutationUpdateToken = (onSuccess, onError) => {
    return {
        mutationFn: (tokenUpdated) => {
            return client.put(TOKEN.UPDATE.url, tokenUpdated);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateToken;